<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title">Auth User Search</h4>
                    <a [ngClass]="[CanCreate ? 'btn btn-success' : 'btn btn-btn-success hind']" routerLink="/Auth/AuthUser/New" role="button" id="btnCreate">Create</a>
                    <app-ngbAccordion class="m-t-10" headerName="Search Criteria">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="useraccount">UserAccount</label>
                                    <input type="text" class="form-control" id="useraccount" [(ngModel)]="model.filter.UserAccount" placeholder="">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="username">UserName</label>
                                    <input type="text" class="form-control" id="username" [(ngModel)]="model.filter.UserName" placeholder="">
                                </div>
                            </div>
                        </div>
                        <button type="button" class="btn btn-secondary" (click)="this.model.filter.PageIndex = 1;Search()">Search</button>
                    </app-ngbAccordion>
                    <app-ngbAccordion class="m-t-10" headerName="Search Result">
                        <div class="rowCard">
                            <app-table-pager [Income]="TableData" (PageInfo)="onChangePageInfo($event)"></app-table-pager>
                        </div>
                        <app-table [Income]="TableData" [TableSetting]="TableSetting" (DeleteEvent)="Delete($event)" (TableInfo)="onChangeTableInfo($event)">
                        </app-table>
                        <div class="dataTb">
                            <app-table-pager [Income]="TableData" (PageInfo)="onChangePageInfo($event)"></app-table-pager>
                        </div>
                    </app-ngbAccordion>
                </div>
            </div>
        </div>
    </div>
</div>